module.exports = __webpack_public_path__ + "static/media/flow-popup.c7eccc47.png";